import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'
import Utility from '@/utils/Utility'

export default {
  name: 'UserInput',
  data () {
    return {
      processing: false,

      // テーブルオプション
      tableColumns: [
        'linkedCmsMstId',
        'linkedCmsName',
        'linkedCmsDomain',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          linkedCmsMstId: '連携CMS ID',
          linkedCmsName: '連携CMS名',
          linkedCmsDomain: '連携CMSドメイン',
          deleteButton: ''
        },
        columnsClasses: {
          linkedCmsMstId: 'wp-10',
          linkedCmsName: '',
          linkedCmsDomain: '',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'linkedCmsMstId',
          'linkedCmsName',
          'linkedCmsDomain'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('連携CMS'),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.user.categoryName,

      // form
      userIdentity: state => state.userForm.targetId,
      values: state => state.userForm.values,

      // model
      serviceModel: state => state.userForm.serviceModel,
      linkedCmsMstModel: state => state.userForm.linkedCmsMstModel,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,
    }),
    ...mapGetters({
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      loginUserUuid: 'auth/userIdentity',
      permittedView: 'permission/permittedView',
      isRegister: 'userForm/isRegister',
      isModify: 'userForm/isModify',
    }),

    // list
    roleList () {
      return this.isAdmin
        ? Constants.UserRole
        : Constants.UserRole.filter(item => item.value !== 1)
    },
    serviceList () {
      let list = []
      this.serviceModel
        .filter(item => item.serviceStatus === 1)
        .forEach(item => list.push({
        value: item.serviceUuid,
        label: item.serviceName
      }))
      return list
    },
    relationCmsList () {
      // if (!this.values.inpCmsList) return []
      let list = this.linkedCmsMstModel.filter(item => this.values.inpCmsList.findIndex(id => id === item.linkedCmsMstUuid) !== -1)
      return list
      // console.log(this.values.inpCmsList)
      // return [
      //   {
      //     linkedCmsMstUuid: 1
      //   }
      // ]
    },
    statusList () {
      return Constants.Status
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // result
    resultLastLogin () {
      return Utility.dateFormat(this.values.lastLoginAt, 'YYYY/MM/DD HH:mm')
    },

    // input
    inpName: {
      get () {
        return this.values.inpName
      },
      set (value) {
        this.setInputValue({
          key: 'inpName',
          value: value
        })
      }
    },
    inpEmail: {
      get () {
        return this.values.inpEmail
      },
      set (value) {
        this.setInputValue({
          key: 'inpEmail',
          value: value
        })
      }
    },
    inpRoleKbn: {
      get () {
        return this.values.inpRoleKbn
      },
      set (value) {
        this.setInputValue({
          key: 'inpRoleKbn',
          value: value
        })
      }
    },
    inpService: {
      get () {
        return this.values.inpService
      },
      set (value) {
        this.setInputValue({
          key: 'inpService',
          value: value
        })
      }
    },
    inpCmsList: {
      get () {
        return this.values.inpCmsList
      },
      set (value) {
        this.setInputValue({
          key: 'inpCmsList',
          value: value
        })
      }
    },
    inpStatus: {
      get () {
        return this.values.inpStatus
      },
      set (value) {
        this.setInputValue({
          key: 'inpStatus',
          value: value
        })
      }
    },

    // enable
    showSelectService () {
      return this.isAdmin && this.inpRoleKbn !== 1
    },
    showSelectCms () {
      return this.inpRoleKbn === 4 &&
        this.inpServiceIsValid
    },

    // validate
    inpNameIsValid () {
      return Validator.validText(this.inpName)
    },
    inpEmailIsValid () {
      return Validator.validText(this.inpEmail)
    },
    inpRoleKbnIsValid () {
      return Validator.validSelect(this.inpRoleKbn)
    },
    inpServiceIsValid () {
      return Validator.validSelect(this.inpService)
    },
    inpCmsListIsValid () {
      return Validator.validArray(this.inpCmsList)
    },
    formIsValid () {
      const f1 = this.inpNameIsValid &&
        this.inpEmailIsValid &&
        this.inpRoleKbnIsValid

      switch (this.inpRoleKbn) {
        case 1: // システム管理者
          return f1
        case 2: // サービス運用担当者
          return f1 && this.inpServiceIsValid
        case 4: // 外部連携CMS担当者
          return f1 && this.inpServiceIsValid && this.inpCmsListIsValid
      }
    },
    disableResetButton() {
      return this.loginUserUuid === this.values.userUuid;
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    'values.inpCmsList': function (to) {
      console.log('relationCmsList', this.relationCmsList)
      // 連携CMSのテーブルデータ
      this.tableData = this.relationCmsList
    },
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'password') {
        if (to) this.resetPassword()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      showAccountSelectLinkedCmsModal: 'accountSelectLinkedCmsModal/show'
    }),
    ...mapMutations({
      setValues: 'userForm/setValues',
      setInputValue: 'userForm/setInputValue'
    }),
    init () {
      // 連携CMSのテーブルデータ
      this.tableData = this.relationCmsList

      // サービス運用車の場合
      if (this.isOperator) {
        this.inpService = this.userServiceUuid
      }
    },
    turnBack () {
      this.$router.push({
        name: 'User'
      })
    },

    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      // switch (key) {
      //   case 'deleteButton':
      //     return props.row.linkedCmsMstUuid
      // }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    confirmData () {
      // validate
      if (this.formIsValid) {
        this.$router.push({
          name: 'UserConfirm'
        })
      }
    },

    showUserCmsModal () {
      this.showAccountSelectLinkedCmsModal({
        serviceId: this.inpService
      })
    },
    deleteItem (props) {
      let list = this.values.inpCmsList.filter(id => id !== props.row.linkedCmsMstUuid)
      this.setInputValue({
        key: 'inpCmsList',
        value: list
      })
    },

    confirmResetPassword() {
      if (this.disableResetButton) return;

      this.showConfirm({
        key: 'password',
        title: 'パスワードリセット確認',
        body: 'パスワードをリセットします<br />よろしいですか',
        acceptLabel: 'リセット'
      })
    },
    resetPassword() {
      this.processing = true

      let parameters = {
        userUuid: this.userIdentity
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['user'],
        ['v1UserPasswordReset'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: 'パスワードリセット',
              body: 'パスワードをリセットしました。'
            })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
  }
}
